import React from 'react';
import { Button, Space } from 'antd';
import { RefSetCurrentPage } from '../hooks/NavigationHooks';
import * as locCon from '../LocalConstants';
import Title from 'antd/es/typography/Title';
import { RefStoredValue } from '../hooks/GeneralStoreHooks';
import { RefContextLanguage } from '../providers/LanguageProvider';

function DashboardSelect() {
  // Current Page
  const setCurrentPage = RefSetCurrentPage();

  const userType = RefStoredValue(locCon.USER_TYPE);

  const i18n = RefContextLanguage();

  return (
    <div className="App">
      <header className="App-header">
        <Space direction="vertical">
          <Title level={2}>{i18n.t('deploymentAndCollectionMonitoring')}</Title>
          <Button type="primary" onClick={() => setCurrentPage(locCon.PAGE_DASHBOARD_EXPIRY_PARTICIPANTS)}>
            {i18n.t('participantDataAboutToExpireView')}
          </Button>
          <Button type="primary" onClick={() => setCurrentPage(locCon.PAGE_DASHBOARD_PRIORITY_VISITS)}>
            {i18n.t('priorityParticipantVisits')}
          </Button>
          <Button type="primary" onClick={() => setCurrentPage(locCon.PAGE_DASHBOARD_DEPLOYMENT_STATUS)}>
            {i18n.t('participantDeploymentStatusView')}
          </Button>
          <Button type="primary" onClick={() => setCurrentPage(locCon.PAGE_DASHBOARD_PARTICIPANTS_TO_BE_UNENROLLED)}>
            {i18n.t('participantsReadyForUnenrollment')}
          </Button>

          {/* <Button type="primary" onClick={() => setCurrentPage(locCon.PAGE_DASHBOARD_ACTION_ITEMS)}>Action Items View</Button> */}
          {/* <Button type="primary" onClick={() => setCurrentPage(locCon.PAGE_DASHBOARD_COLLECTION_STATUS)}>Participant Collection Status View</Button> */}

          <Title level={2}>{i18n.t('overallProgress')}</Title>
          <Button type="primary" onClick={() => setCurrentPage(locCon.PAGE_DASHBOARD_DEPLOYMENT_PROGRESS)}>
            {i18n.t('deploymentProgressView')}
          </Button>
          <Button type="primary" onClick={() => setCurrentPage(locCon.PAGE_DASHBOARD_GLOBAL_COLLECTION_PROGRESS)}>
            {i18n.t('globalCollectionStatusView')}
          </Button>

          <Title level={2}>{i18n.t('tools')}</Title>
          <Button type="primary" onClick={() => setCurrentPage(locCon.PAGE_DASHBOARD_GOVEE_CODES)}>
            {i18n.t('goveeActivationCodes')}
          </Button>

          {userType !== locCon.USER_TYPE_SEWA ? (
            <div />
          ) : (
            <Space direction="vertical">
              <Button type="primary" onClick={() => setCurrentPage(locCon.PAGE_DASHBOARD_NAME_MATCHER)}>
                {i18n.t('nameMatcher')}
              </Button>
              {/* <Button type="primary" onClick={() => setCurrentPage(locCon.PAGE_DASHBOARD_LAB_UPLOADS)}>
                Lab Uploads
              </Button> */}

              <Button type="primary" onClick={() => setCurrentPage(locCon.PAGE_PARTICIPANT_UNENROLL)}>
                {i18n.t('participantUnenroll')}
              </Button>

              <Button type="primary" onClick={() => setCurrentPage(locCon.PAGE_DASHBOARD_DOCUMENTS)}>
                {i18n.t('downloadDocuments')}
              </Button>
            </Space>
          )}
        </Space>
      </header>
    </div>
  );
}

export default DashboardSelect;
